import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import React from "react";

export default function Banner() {
  return (
    <Flex
      bgImage={"url('/images/about/banner.png')"}
      height={{base:"280px",md:"420px"}}
      bgSize={"cover"}
      bgRepeat="no-repeat"
      justifyContent={"start"}
      alignItems="center"
      flexDirection="column"
      color="white"
      gap={5}
      backgroundPosition="center"
      my={{base:6,md:10}}
    >
      <Stack alignItems="center" mt={{base:10,md:20}} maxW={"850px"}>
        <Heading
          fontWeight={"semibold"}
          fontSize={{ base: "16px",sm:"20px", md: "36px" }}
          textAlign="center"
          maxW={"80%"}
        >
          Step Into The Future Of Freelancing With Decolance
        </Heading>
        <Text
          fontSize={{ base: "12px",sm: "14px", md: "18px" }}
          align="center"
          color="white"
          w="90%"
        >
          Decolance is a revolutionary decentralized freelancing marketplace
          designed to create a global business ecosystem powered by the secure
          exchange of digital services. Modern business demands necessitate
          modern business transactions, and this is precisely what Decolance
          does best.
        </Text>
      </Stack>
    </Flex>
  );
}
